export default __webpack_public_path__ + "static/media/3dcoll.a79b6e34.svg";